import { clsx } from 'clsx'
import Link from 'next/link'

import { DotsIcon } from '@/widgets/Header/ui/assets/dots-icon'
import { RegionSelector } from '@/widgets/RegionSelector'

import { useRegion } from '@/entities/regions'

import { useVisibleItems } from '@/shared/lib/hooks/useVisibleItems'
import { Button } from '@/shared/ui'
import { Tooltip } from '@/shared/ui/react-tooltip/react-tooltip'

import { data } from './data'

import cl from './style.module.scss'

export const PreHeader = () => {
	const { currentRegion } = useRegion()

	const { visibleItems, hiddenItems } = useVisibleItems({
		items: data,
		breakpoints: [
			{ width: 950, count: 3 },
			{ width: 1030, count: 4 },
			{ width: 1200, count: 5 },
			{ width: 1370, count: 6 },
			{ width: 1450, count: 8 }
		]
	})

	return (
		<section className={clsx('js-preHeader', cl.preheader)}>
			<div className={cl.container}>
				<div className={cl.wrapper}>
					<RegionSelector type="header" />

					<nav aria-label="Информационные страницы">
						<ul className={cl.list}>
							{visibleItems.map(({ NAME, LINK, targetBlank, ICON }) => (
								<Link
									prefetch={false}
									href={LINK}
									target={targetBlank ? `_blank` : `_self`}
									className="topLink"
									key={LINK}>
									<li key={LINK}>
										{ICON && <ICON />}
										<p>{NAME}</p>
									</li>
								</Link>
							))}

							{hiddenItems.length > 0 && (
								<>
									<Button
										theme={'clear'}
										id={'extra-preheader-items'}
										data-tooltip-id={'#extra-preheader-items'}
										className={cl.btn}>
										<span style={{ fontSize: `0`, lineHeight: `0` }}>Показать еще</span>
										<DotsIcon />
									</Button>
									<Tooltip
										id={'#extra-preheader-items'}
										place={'top-start'}
										offset={14}
										noArrow={true}
										clickable={true}
										className={clsx(cl.tooltip, cl.extra)}>
										{hiddenItems.map(({ NAME, LINK, targetBlank, ICON }) => (
											<Link prefetch={false} href={LINK} target={targetBlank ? `_blank` : `_self`} key={LINK}>
												{ICON && <ICON />}
												{NAME}
											</Link>
										))}
									</Tooltip>
								</>
							)}
						</ul>
					</nav>
				</div>

				<Link
					prefetch={false}
					href={`tel:` + currentRegion.REGION_PHONE}
					className={clsx('gtm-header-phone', cl.phone)}>
					{currentRegion.REGION_PHONE}
				</Link>
			</div>
		</section>
	)
}
